import React from 'react';
import { Box } from '@mui/material';
import { formatPhoneNumberIntl } from 'react-phone-number-input';
import {
  ButtonContinue,
  ContainerFinProfile,
  ContainerPhone,
  LabelError,
  LabelPhone,
  PhoneTitle,
} from './find-profile.styled';
import PhoneNumber from '@/modules/PhoneNumber';
import useUser from '@authentication/hooks/useUser';
import Candidates from '../Candidates';
import { getCandidatesByPhone } from '@services/candidateServices';
import { CandidatesTitle, Circle } from '../Candidates/candidates.style';
import { ReactComponent as Arrow } from '../../assets/icons/FrameArrow.svg';

function FindProfileCard() {
  const [phoneNumber, setPhoneNumber] = React.useState('');
  const [errorMessageCandidate, setErrorMessageCandidate] = React.useState('');
  const [hasError, setHasError] = React.useState<boolean>(false);
  const { pageTitle, setPageTitle } = useUser();
  React.useEffect(() => {
    setPageTitle('Trouvez votre profil');
  }, [pageTitle]);

  const { setCandidates, candidates } = useUser();
  const [count, setCount] = React.useState(0);
  const [isPhoneValid, setIsPhoneValid] = React.useState(false);

  const handleBack = () => setCount(count - 1);
  const handleSearchCandidateByPhoneNumber = async () => {
    const phone = formatPhoneNumberIntl(phoneNumber);

    if (phone) {
      setErrorMessageCandidate('');
      setHasError(false);

      setCandidates([]);
      const findCandidate: any = await getCandidatesByPhone(phone);

      if (findCandidate?.data?.items && findCandidate?.data?.items.length > 0) {
        setCandidates(findCandidate.data.items);
        setCount(count + 1);
      } else {
        setHasError(true);
        setErrorMessageCandidate(
          'Aucun profil ne correspond à ce numéro. Veuillez vérifier le numéro de mobile.',
        );
      }
    }
  };

  const handlePhoneNumber = (value: string) => {
    setPhoneNumber(value);

    if (value && value.length === 12) {
      setIsPhoneValid(true);
      setHasError(false);
    } else {
      setIsPhoneValid(false);
      setHasError(true);
    }
  };

  const handleClick = async () => {
    handleSearchCandidateByPhoneNumber();
  };

  return (
    <ContainerFinProfile
      sx={{
        display: 'flex',
        marginTop: 4,
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
      }}
    >
      <ContainerPhone>
        {count === 1 ? (
          <Box sx={{ height: '320px' }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                overflow: 'hidden',
              }}
            >
              <Circle onClick={handleBack}>
                <Arrow
                  style={{
                    display: 'inline-block',
                    transform: 'scaleX(-1)',
                  }}
                />
              </Circle>

              <CandidatesTitle>
                {errorMessageCandidate.length === 0
                  ? 'Confirmez votre profil'
                  : ''}
              </CandidatesTitle>
            </Box>

            <Box
              sx={{
                height: '160px',
                position: 'sticky',
                overflow: 'auto',
                top: 0,
              }}
            >
              {candidates && <Candidates data={candidates} />}
            </Box>
          </Box>
        ) : (
          <>
            <LabelPhone>Votre numéro de mobile</LabelPhone>
            <Box sx={{ width: '95%' }}>
              <PhoneNumber
                error={hasError}
                number={phoneNumber}
                handlePhoneNumber={handlePhoneNumber}
              />
            </Box>
            {errorMessageCandidate.length === 0 ? (
              <PhoneTitle>
                Saisissez le même numéro de mobile utilisé sur la borne StoreRH
              </PhoneTitle>
            ) : (
              <LabelError>{errorMessageCandidate}</LabelError>
            )}

            <ButtonContinue
              variant="contained"
              disabled={!isPhoneValid}
              onClick={handleClick}
            >
              Continue
              <Arrow
                style={{
                  display: 'inline-block',
                  transform: 'scaleX(1)',
                  color: 'white',
                }}
              />
            </ButtonContinue>
          </>
        )}
      </ContainerPhone>
    </ContainerFinProfile>
  );
}

export default FindProfileCard;
